import { render, staticRenderFns } from "./company-quote-plan-info.vue?vue&type=template&id=42ace2b2&scoped=true&"
import script from "./company-quote-plan-info.vue?vue&type=script&lang=js&"
export * from "./company-quote-plan-info.vue?vue&type=script&lang=js&"
import style0 from "./company-quote-plan-info.vue?vue&type=style&index=0&id=42ace2b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ace2b2",
  null
  
)

export default component.exports